import { z } from "zod";
import { ISODateSchema, ULIDSchema } from "./primitives.js";
import { UserIdSchema } from "./user.js";
export const RoleSchema = z.enum(["owner", "member"]);
export const MembershipSchema = z
    .object({
    // Note: `userId` here is the raw Cognito sub (UUID-shaped), not a ULID — see the
    // "Resolved scope decisions" #9 note in the plan front-matter.
    userId: UserIdSchema,
    householdId: ULIDSchema("hh"),
    schemaVersion: z.literal(1),
    role: RoleSchema,
    joinedAt: ISODateSchema,
})
    .passthrough();
//# sourceMappingURL=membership.js.map